import { api } from '../../lib/api';

/**
 * Downloading the brand document from the Edit page's sources list (spec:190, E32). The file comes
 * through the API with the bearer token (it is never a public link), so it is fetched as a Blob and
 * handed to the browser as a download.
 */

/**
 * Hands a fetched blob to the browser as a file download. The same steps as `saveBlob` in
 * features/media/mediaDisplay.ts, which keeps it private to the Media Library.
 */
export function saveBlobAs(blob: Blob, fileName: string): void {
  const url = URL.createObjectURL(blob);
  try {
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    a.remove();
  } finally {
    URL.revokeObjectURL(url);
  }
}

/**
 * Downloads the original document of an import job under its file name. Any reader of the workspace may
 * (the server checks). Rejects when the file cannot be fetched (a newer upload replaced it, or the
 * request failed): the caller shows "Couldn't download this file. Try again."
 */
export async function downloadBrandDocument(tenantId: string, jobId: string, fileName: string): Promise<void> {
  const blob = await api.downloadBrandDocument(tenantId, jobId);
  saveBlobAs(blob, fileName);
}
